import React, { useRef } from 'react';
import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import CounselingAccordion from './CounselingAccordion';
import CounselingSecColSubChildUnRegister from './CounselingSecColSubChildUnRegister';
import CounselingSecColSubChild from './CounselingSecColSubChild';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { handleCounsellingFormMidItem } from '../../httpdata/appointmentsdata';
import setUiMessage from '../../Utilities/Tostify';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';

function ConsultationPopup({
  handleClose,
  patientId,
  soapId,
  appId,
  visitId,
  handleReload,
}) {
  const [allData, setAllData] = useState(false);
  const [textAreaData, setTextAreaDataData] = useState({});
  const [checkBoxData, setCheckBoxData] = useState({});
  const [showHideChiled, setShowHideChiled] = useState('1_2');
  const [classFirstCol, setClassFirstCol] = useState('1_2');
  const [checkedAll, setCheckedAll] = useState({});
  const [childId, setChildId] = useState('');
  const [catAndId, setCatAndId] = useState('1_2');
  const [childSerch, setChildSerch] = useState({});
  const [accord, seAccord] = useState({});

  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const scrollRefs = useRef([]);
  const checkboxRef = useRef([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openConsultationPopup',
          {
            patientId: patientId,
            soapId: soapId,
            appId: appId,
            visitId: visitId,
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `consultDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3];
              });
              return acc;
            },
            {},
          );
          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (data[1] === 'Problem' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `consultSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.id}`;

                      acc[key] = false;
                    }
                  }
                  subData[2] &&
                    subData[2]?.forEach((subChildData) => {
                      const key = `consultSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                      acc[key] =
                        subChildData?.is_checked === '1' ? true : false;
                    });
                });
              return acc;
            },
            {},
          );
          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, soapId, appId, visitId]);

  const handleCounsellingFormSave = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/saveConsultationForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          visitId: visitId,
          staffUserId: user?.id,
          consultationDataJson: getTherapyJson(),
        },
      );
      if (response.status === 200) {
        handleClose();
        handleReload('consultation');

        dispatch(
          setRenderFormData({
            data: { consultationData: response.data.renderConsultationData },
            type: 'consultation',
          }),
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingFormUpdate = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/updateConsultationForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          staffUserId: user?.id,
          consultationDataJson: getTherapyJson(),
        },
      );
      if (response.status === 200) {
        handleClose();
        handleReload('consultation');
        dispatch(
          setRenderFormData({
            data: { consultationData: response.data.renderConsultationData },
            type: 'consultation',
          }),
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getTherapyJson = () => {
    let masterArr = [];
    let hisAndSymMaster = document.querySelectorAll('.consultAddEditSection');
    let retStr = false;
    if (hisAndSymMaster) {
      hisAndSymMaster.forEach(function (element) {
        const masterId = element.getAttribute('value');
        let masterText = document.querySelector(
          '#consultDetailsText_' + masterId,
        ).value;

        let hisAndSymChield = document.querySelectorAll(
          '.consultMasterSubChildData_' + masterId,
        );

        let childArr = [];
        hisAndSymChield.forEach(function (element, i) {
          let childIdTextArr = element.getAttribute('id').split('_');

          let childText = document.getElementById(
            'consultSubChildDataList_' + masterId + '_' + childIdTextArr[3],
          ).textContent;

          childArr.push({
            masterId: masterId,
            childId: childIdTextArr[3],
            childText: childText.trim(),
            childInput: checkBoxData[element.getAttribute('id')] ? '1' : '0', //isChecked ? '1' : '0',
          });
        });
        masterArr.push({
          masterId: masterId,
          masterText: masterText,
          childArr: childArr,
        });
      });
      retStr = JSON.stringify(masterArr);
    }
    return retStr;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleCheckBoxLable = (eleId) => {
    const target = checkboxRef.current[eleId];
    let checked = !target.checked;
    handleCheckBoxChangeComn(eleId, checked);
    setCheckBoxData({
      ...checkBoxData,
      [eleId]: checked ? true : false,
    });
  };

  const handleCheckBoxChange = (e) => {
    const { id, checked } = e.target;
    setCheckBoxData({
      ...checkBoxData,
      [id]: checked ? true : false,
    });

    handleCheckBoxChangeComn(id, checked);
  };

  const handleCheckBoxChangeComn = (id, checked) => {
    const idArr = id?.split('_');

    const selStr = document?.querySelector(
      '#consultSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
    ).textContent;
    setChildId(idArr[1] + '_' + idArr[2]);
    let textData =
      textAreaData['consultDetailsText_' + idArr[1] + '_' + idArr[2]];
    if (checked) {
      textData = textData?.replace(selStr, '');
      textData = textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['consultDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
          ? textData + ', ' + selStr
          : selStr,
      });
    } else {
      if (textData?.indexOf(', ' + selStr) === -1) {
        textData = textData?.replace(selStr + ', ', '');
      } else {
        textData = textData?.replace(', ' + selStr, '');
      }
      textData = textData?.replace(selStr, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['consultDetailsText_' + idArr[1] + '_' + idArr[2]]: textData,
      });
    }
  };

  useEffect(() => {
    if (childId) {
      let allChecked = true;
      const newObj = {};
      // const spl = childId?.split('_');
      for (const key in checkBoxData) {
        if (key.startsWith('consultSubChildDataListInpt_' + childId + '_')) {
          newObj[key] = checkBoxData[key];
        }
      }

      for (const i in newObj) {
        if (newObj[i] === false) {
          allChecked = false;
        }
      }

      Object.keys(newObj).length !== 0 &&
        setCheckedAll((prevState) => ({
          ...prevState,
          [childId]: allChecked,
        }));
    }
  }, [checkBoxData, childId]);

  const handleSubDataShow = (id) => {
    setShowHideChiled(id);
    setClassFirstCol(id);
    setCatAndId(id);
    setChildId(id);
    const target = scrollRefs.current['consultDetailsText_' + id];
    target.scrollIntoView({ behavior: 'smooth' });
  };

  const selectAll = (e, id) => {
    const { checked } = e.target;
    setCheckedAll({ ...checkedAll, [id]: checked ? true : false });

    let secColdata = document.querySelectorAll(
      '.consultMasterSubChildData_' + id,
    );
    let finalText = '';
    secColdata.forEach(function (element, i) {
      let idArr = element.getAttribute('id').split('_');
      let selStr = document.getElementById(
        'consultSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
      ).textContent;

      if (checked) {
        checkBoxData[element.getAttribute('id')] = checked;
        finalText += selStr + ', ';
      } else {
        checkBoxData[element.getAttribute('id')] = checked;
      }
    });
    finalText = finalText.slice(0, -2);
    setTextAreaDataData({
      ...textAreaData,
      ['consultDetailsText_' + id]: finalText,
    });
  };

  const handleChildSerch = (e, id) => {
    const { value } = e.target;
    setChildSerch({});
    setChildSerch({ ...childSerch, [id]: value });
  };

  useEffect(() => {
    if (childSerch.length > 0) {
      let userInput = childSerch[catAndId]?.replace(/\\/g, '').toLowerCase();
      let secCol = document.querySelectorAll(
        '.consultMasterSubChildData_' + catAndId,
      );
      secCol?.forEach(function (element, i) {
        let searchTerm = element.getAttribute('data-search-term').toLowerCase();
        if (searchTerm.search(userInput) === -1) {
          element.classList.add('hide');
        } else {
          element.classList.remove('hide');
        }
      });
    }
  }, [childSerch, catAndId]);

  const handleRemoveSubChild = (id) => {
    setRemoveSubChild(true);
    setSucPrams(id);
  };

  const handleRemoveSubChildConfirm = async (id) => {
    const idArr = id.split('_');
    const itemId = idArr[2];
    if (itemId) {
      const response = await handleCounsellingFormMidItem(itemId, 'pc');
      if (response?.status === 200) {
        if (response.data.message === 'success') {
          setUiMessage('suc', 'Record deleted successfully.');
          setCheckBoxData({
            ...checkBoxData,
            ['consultSubChildDataListInpt_' + id]: false,
          });
          const split = id?.split('_');
          const selStr = document?.querySelector(
            '#consultSubChildDataList_' + id,
          ).innerHTML;

          setChildId(split[0] + '_' + split[1]);

          let textData =
            textAreaData['consultDetailsText_' + split[0] + '_' + split[1]];

          if (textData?.indexOf(', ' + selStr) === -1) {
            textData = textData?.replace(selStr + ', ', '');
          } else {
            textData = textData?.replace(', ' + selStr, '');
          }

          textData?.replace(/^,*\s*|,*\s*$/, '');
          setTextAreaDataData({
            ...textAreaData,
            ['consultDetailsText_' + split[0] + '_' + split[1]]: textData,
          });

          const element = document.querySelector(
            '#consultSubChildDataListInpt_' + id,
          );
          element.remove();
          setRemoveSubChild(false);
        }
      } else {
        setUiMessage('err', 'Something went wrong.');
      }
    }
  };

  const handleCloseFun = (type) => {
    if (type === 'silent') {
      handleClose();
      return;
    }
    if (allData.mode === 'add') {
      handleCounsellingFormSave();
    } else if (allData.mode === 'edit') {
      handleCounsellingFormUpdate();
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr mat-cnslng-fu-con center-popup">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">
              Consultation [DOS: {allData?.dos}]:
            </span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.chartNo}
          </div>
          <Button variant="circle" onClick={handleCloseFun}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy mat-cnslng-fu-bdy flex-sec">
          <div className="mat-cnslng-col1">
            {allData?.therapyMasterData?.map((data, r) => (
              <CounselingAccordion
                key={r}
                classFirstCol={classFirstCol}
                accord={accord}
                handleSubDataShow={handleSubDataShow}
                parent={data}
                handleClick={(id) => {
                  seAccord(data[3]);
                  handleSubDataShow(data[3] + '_' + data[2][0][0]);
                }}
                moduleName={'consultAddEditSection'}
              />
            ))}
          </div>
          <div className="mat-cnslng-col2">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i}>
                {data[2] &&
                  data[2]?.map((subData, j) => (
                    <div
                      key={j}
                      id={'consultSubChildBox_' + data[3] + '_' + subData[0]}
                      className={
                        showHideChiled === data[3] + '_' + subData[0]
                          ? ''
                          : 'hide'
                      }
                      style={{ height: '100%' }}
                    >
                      <div className="sec-col-serch">
                        <span className="clear5 clear-left10">
                          <input
                            type="checkbox"
                            checked={checkedAll[data[3] + '_' + subData[0]]}
                            onChange={(e) =>
                              selectAll(e, data[3] + '_' + subData[0])
                            }
                          />
                        </span>
                        <span className="clear-left10">
                          <input
                            type="search"
                            className="cnslng-fu-chld-srch"
                            placeholder="Search here..."
                            value={childSerch[data[3] + '_' + subData[0]] || ''}
                            onChange={(e) =>
                              handleChildSerch(e, data[3] + '_' + subData[0])
                            }
                          />
                        </span>
                      </div>

                      {(data[1] === 'Problem' &&
                        subData[1] === 'Current Problems' &&
                        allData?.probArr && (
                          <CounselingSecColSubChildUnRegister
                            data={data}
                            subData={subData}
                            checkBoxData={checkBoxData}
                            handleCheckBoxChange={handleCheckBoxChange}
                            handleRemoveSubChild={handleRemoveSubChild}
                            moduleName={'consult'}
                            allData={allData?.probArr}
                            checkboxRef={checkboxRef}
                            handleCheckBoxLable={handleCheckBoxLable}
                          />
                        )) || (
                        <CounselingSecColSubChild
                          data={data}
                          subData={subData}
                          checkBoxData={checkBoxData}
                          handleCheckBoxChange={handleCheckBoxChange}
                          handleRemoveSubChild={handleRemoveSubChild}
                          moduleName={'consult'}
                          checkboxRef={checkboxRef}
                          handleCheckBoxLable={handleCheckBoxLable}
                          editModeEnabled={true}
                        />
                      )}
                    </div>
                  ))}
              </div>
            ))}
          </div>
          <div className="mat-cnslng-col3">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i}>
                {data[2]?.map((subData, j) => (
                  <div
                    key={j}
                    className="grid-sec"
                    ref={(el) =>
                      (scrollRefs.current[
                        'consultDetailsText_' + data[3] + '_' + subData[0]
                      ] = el)
                    }
                  >
                    <span className="pop-up-sb-hdr">{subData[1]}</span>
                    <textarea
                      className="cnslng-poup-txtrea"
                      placeholder="Write here..."
                      id={'consultDetailsText_' + data[3] + '_' + subData[0]}
                      name={'consultDetailsText_' + data[3] + '_' + subData[0]}
                      spellCheck="true"
                      value={
                        textAreaData &&
                        textAreaData[
                          'consultDetailsText_' + data[3] + '_' + subData[0]
                        ]
                      }
                      onChange={handleInputChange}
                      style={{ height: '214px' }}
                    ></textarea>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          {(allData.mode === 'add' && (
            <button className="actn-yes" onClick={handleCounsellingFormSave}>
              Save
            </button>
          )) ||
            (allData.mode === 'edit' && (
              <button
                className="actn-yes"
                onClick={handleCounsellingFormUpdate}
              >
                Update
              </button>
            ))}
          <button className="actn-No" onClick={handleCloseFun}>
            Cancel
          </button>
        </div>
        {removeSubChild && (
          <ConfirmDialog
            bodytext={'Do you want to remove it?'}
            closeDialog={() => setRemoveSubChild(false)}
            successDialog={handleRemoveSubChildConfirm}
            sucPrams={sucPrams}
          />
        )}
      </div>
    </div>
  );
}

export default ConsultationPopup;
